/* istanbul ignore file */
import _ from 'underscore';

export const MtErrorMessages = {

  // Unknown error used to indicate MT returns error such as 400,
  // but error json is not a recognized shema.
  UnknownError: _TL_('Unknown error'),
  Unauthorized: _TL_('Unauthorized'),
  InternalServerError: _TL_("We've encountered an error and could not finish this task. Please try again or contact support."),
  MmcRequestParseErr: _TL_('Unable to Parse the Request Body'),

  // Store errors
  DuplicateStoreNameErr: _TL_('Store name is already used'),
  StoreNotFoundErr: _TL_('The store you selected has been deleted. Create a new store or select another one.'),
  MarketUsedInAnotherStoreWithSameDomainErr: _TL_('This domain is already associated with more stores than supported markets. You can only have one store per supported market.'),
  ExceededMaxStoresForDestinationUrlErr: _TL_('There are already more stores than markets we support associated with this domain {0}'),
  InvalidStoreNameErr: _TL_('The store name is invalid.'),
  InvalidStoreDescriptionErr: _TL_('The store description is invalid.'),
  ExceededMaxStoresForCustomerErr: _TL_('Max stores reached for the customer.'),
  NoDomainsFoundForCustomerErr: _TL_('No domains found for the customer.'),
  DomainNotOwnedByCustomerErr: _TL_('Specified domain is not owned by the customer.'),
  StoreNotCompliantErr: _TL_('Feed creation is not allowed as store is not compliant.'),
  AdultAdvertiserErr: _TL_('Adult advertiser'),
  InvalidEmailAddressErr: _TL_('Contact email is missing.'),
  CreateStoreWithFraudDomainErr: _TL_('This domain is disallowed due to violation of our policies. Please contact Support for further assistance.'),
  StoreDeleteNotAllowedErr: _TL_('This store cannot be deleted, because it was rejected. Please reach out to Ads Support if you have any questions.'),
  GmcMappingExists: _TL_('Google Merchant Id is already mapped.'),
  GmcDomainNotClaimed: _TL_('The domain is not claimed for the Google Merchant Id.'),
  DuplicateDomainNameErr: _TL_('An error occurred while saving the store mappings. Another store with the same domain name exists.'),

  // Feed errors
  MarketNotSupportedErr: _TL_('The market is not supported for a given Feed'),
  UploadMethodNotSupportedErr: _TL_('Upload Method is not supported for a given Feed'),
  InvalidFeedFileNameErr: _TL_('Enter letters and numbers without an extension.'),
  InvalidFeedNameErr: _TL_('The feed name is invalid.'),
  DuplicateFeedFileNameErr: _TL_('Another feed has this file name. Enter a different one.'),
  MaxFeedLimitReachedErr: _TL_('Maximum number of feeds per market reached for the current store.'),
  DuplicateSourcePullUrlErr: _TL_('Another feed is set to download its feed file automatically from this URL. Please use a different URL for the feed file of this catalog.'),
  InvalidPullUserNameErr: _TL_('The user name is invalid'),
  InvalidPullPasswordErr: _TL_('Enter a different password because this one is not Cross Site Scripting safe.'),
  FeedNotFoundErr: _TL_('The feed you selected has been deleted.'),
  FeedPropertyCannotBeChangeOnUpdate: _TL_('Trying to update readonly properties.'),
  DuplicateFeedNameErr: _TL_('Another feed has this name. Enter a different one.'),

  // Import errors
  ImportMarketAlreadyExists: _TL_('An import feed already exists for this target country. Please select a different target country.'),
  ImportExceedGoogleStoreCountLimit: _TL_('The number of Google Merchant Center stores exceed our limit. Please contact Microsoft Advertising Support to resolve this.'),
  ImportFeedTypeNotSupported: _TL_('Can not convert input method to Google import.'),
  GoogleImportCannotRetrieveRefreshToken: _TL_('Cannot retrieve refresh token for Google import. Please sign out and sign in again. And make sure every access option is selected on Google sign-in page.'),
  ImportSetupErr: _TL_('We\'ve encountered an error when settingup import catalog. Please try again or contact support.'),
  ImportMerchantScheduleErr: _TL_('We\'ve encountered an error when settingup schedule. Please try again or contact support.'),
  ImportAlreadyHaveSameFeedUploadMethod: _TL_('This store already has an import catalog with same FeedUploadMethod.'),
  ProductReportNotFoundErr: _TL_('No product report found. Please check if the product offer is empty. If present, please try again or contact support.'),

  // Promotion errors
  PromotionEffectiveEndBeforeNow: _TL_('Enter an effective end date & time past now.'),
  PromotionEffectiveEndOutOfRange: _TL_('Enter an effective end date & time within 6 months of the start date & time.'),
  PromotionMaxEffectivePromotionsReached: _TL_('Max # of effective promotions reached.'),
  PromotionAlreadyExist: _TL_('Promotion already exist.'),
  PromotionBleNotEnabledForCustomer: _TL_('Brand loyalty extension feature is not enabled for this customer'),
  PromotionCreateToWrongStore: _TL_('Promotion\'s providerid doesn\'t match storeid'),
  PromotionBleAssetNotUploaded: _TL_('Merchant asset file not provided or it is empty'),
  PromotionIdAlreadyUsed: _TL_('Another promotion with the same promotion id already exists.'),
  PromotionCannotBeUpdatedAtCurrentState: _TL_('Promotion cannot be updated at its current state.'),
  PromotionCouponTypeInconsistentWithLongTitle: _TL_('Promotion type is inconsistent with title.'),
  PromotionMinimumPurchaseAmountInconsistentWithLongTitle: _TL_('Minimum purchase amount is inconsistent with title.'),
  PromotionMoneyOffAmountInconsistentWithLongTitle: _TL_('Discount amount is inconsistent with title.'),
  PromotionPercentOffAmountInconsistentWithLongTitle: _TL_('Discount percentage is inconsistent with title.'),
  PromotionMoneyOffAmountEmptyInvalid: _TL_('Discount amount is missing.'),
  PromotionPercentOffEmptyInvalid: _TL_('Discount percentage is missing.'),
  PromotionFreeGiftDescriptionEmptyInvalid: _TL_('Free gift with description is missing.'),
  PromotionFreeGiftDescriptionTooLong: _TL_('Free gift with description is too long.'),
  PromotionFreeGiftValueEmptyInvalid: _TL_('Free gift with value is missing.'),
  PromotionMinimumAmountInvalid: _TL_('Minimum quantity of products is invalid.'),

  // Promotion feed errors
  PromotionProductMoneyOffInvalid: _TL_('Amount off value is invalid.'),
  PromotionProductPercentOffInvalid: _TL_('Percent off value is invalid.'),
  PromotionProductFreeGiftDecriptionInvalid: _TL_('Free gift description is invalid.'),
  PromotionProductFreeGiftValueInvalid: _TL_('Free gift value is invalid.'),

  // FTP settings error codes
  FtpSettingsAccountNotFound: _TL_('FTP/SFTP account for this store was not found.'),
  FtpSettingsAccountAlreadyExists: _TL_('FTP/SFTP account already exists for this store.'),
  FtpSettingsAccountIsLocked: _TL_('FTP/SFTP account is locked.'),
  FtpSettingsUserNameNull: _TL_('FTP/SFTP user name is missing.'),
  FtpSettingsUserNameTooLong: _TL_('FTP/SFTP user name is too long.'),
  FtpSettingsUserNameTooShort: _TL_('FTP/SFTP user name is too short.'),
  FtpSettingsUserNameInvalidCharacters: _TL_('FTP/SFTP user name must contain letters or numbers, not special characters.'),
  FtpSettingsUserNameSuspiciousCharacters: _TL_('Enter a different user name because this one is not Cross Site Scripting safe.'),
  FtpSettingUserNameAlreadyUsed: _TL_('FTP/SFTP user name is already used by another account.'),
  FtpSettingsUserNameUnauthorizedChange: _TL_('This account is not authorized to change the FTP/SFTP user name.'),
  FtpSettingsPasswordNull: _TL_('FTP/SFTP password is missing.'),
  FtpSettingsPasswordTooLong: _TL_('FTP/SFTP password is too long.'),
  FtpSettingsPasswordTooShort: _TL_('FTP/SFTP password is too short.'),
  FtpSettingsPasswordInvalidCharacters: _TL_('FTP/SFTP password is invalid.'),
  FtpSettingsPasswordSuspiciousCharacters: _TL_('Enter a different password because this one is not Cross Site Scripting safe.'),
  FtpSettingsPasswordMustContain: _TL_('FTP/SFTP password must contain at least one letter, one number, and one special character.'),

  // Inline appeal
  NonAppealableFlagArea: _TL_('The rejection is not appealable.'),
  AppealQuotaExceeded: _TL_('You have exhausted the monthly appeal limit.'),

  // Shipping settings error codes
  ShippingSettingsDuplicateLabelNameUsed: _TL_('Shipping Label names must be unique.'),
  ReturnPolicyInvalidUrlErr: _TL_('The return policy URL is invalid.'),

  // Product Listings settings error codes
  ProductListingsSettingsUserBlacklisted: _TL_('User is forbidden from showing free Product Listings in the shopping tab. Please contact support for more information.'),
  PublishToMbcFailed: _TL_('Failed to update Product Listings settings due to Kafka error. Please try again or contact support.'),

  // Microsoft Store Ads error codes
  CoOpInvalidSellerIdErr: _TL_('Seller ID already exist.'),
};

export const MtErrorCode = _.object(_.keys(MtErrorMessages), _.keys(MtErrorMessages));
